import HeaderPortal from "components/portal/header-portal";
import { FormColumns, FormLabel } from "components/form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { Form } from "react-crud-form";
import { Input } from "ui/components/input";
import React from "react";
import SelectStatus from "components/select/status"
import { basicDetailSchema } from "./schema";
import { Button } from "ui/index";
import { DatePicker } from "components/date-picker-2";
import { useParams } from "react-router-dom";
import ProjectCombobox from "components/directus/combobox/project";
import { useBasicDetailForm } from "./useBasicDetailForm";

const BasicDetailsForm = () => {

    const { casestudyId } = useParams();

    const {
        form,
        requiredFields,
        handleCreate,
        handleRead,
        handleUpdate,
    } = useBasicDetailForm({ casestudyId });

    return (
        <div className="flex-1 max-w-md p-4">
            <Form
                form={form}
                create={handleCreate}
                read={handleRead}
                update={handleUpdate}
                itemId={casestudyId || "+"}
                schema={basicDetailSchema}
            >
                {({
                    isCreating,
                    createItem,
                    isNewItem,
                    isUpdating,
                    updateItem,
                    isDirty,
                }) => {
                    return (
                        <div className="space-y-6">
                            {/* name */}
                            <FormField
                                control={form.control}
                                name="name"
                                render={({ field }) => {
                                    return (
                                        <FormItem>
                                            <FormLabel required={requiredFields.includes(field.name)}>Name</FormLabel>
                                            <Input {...field} />
                                            <FormMessage />
                                        </FormItem>
                                    );
                                }}
                            />

                            {/* Project */}
                            <FormField
                                control={form.control}
                                name="project"
                                render={({ field }) => (
                                    <FormItem>
                                        <FormLabel required={requiredFields.includes(field.name)}>Project</FormLabel>
                                        <ProjectCombobox
                                            value={field.value}
                                            className="w-full"
                                            placeholder="Select"
                                            searchPlaceholder="Search Project..."
                                            hideLabel
                                            onChange={(selectedItem) => field.onChange(selectedItem)}
                                        />
                                        <FormMessage />
                                    </FormItem>
                                )}
                            />


                            <FormColumns >
                                {/* Status */}
                                <FormField
                                    control={form.control}
                                    name="status"
                                    render={({ field }) => (
                                        <FormItem>
                                            <FormLabel required={requiredFields.includes(field.name)}>Status</FormLabel>
                                            <SelectStatus
                                                collection="case_studies"
                                                onValueChange={val => field.onChange(val)}
                                                {...field}
                                            />
                                            <FormMessage />
                                        </FormItem>
                                    )}
                                />

                                {/* Date Started */}
                                <FormField
                                    control={form.control}
                                    name="date_started"
                                    render={({ field }) => {
                                        return (
                                            <FormItem>
                                                <FormLabel required={requiredFields.includes(field.name)}>Date Started</FormLabel>
                                                <DatePicker {...field} />
                                                <FormMessage />
                                            </FormItem>
                                        );
                                    }}
                                />
                            </FormColumns>


                            {/* Tag Line */}
                            <FormField
                                control={form.control}
                                name="tag_line"
                                render={({ field }) => {
                                    return (
                                        <FormItem>
                                            <FormLabel required={requiredFields.includes(field.name)}>Tag Line</FormLabel>
                                            <Input {...field} />
                                            <FormMessage />
                                        </FormItem>
                                    );
                                }}
                            />

                            {/* Project Name Alias */}
                            <FormField
                                control={form.control}
                                name="project_name_alias"
                                render={({ field }) => {
                                    return (
                                        <FormItem>
                                            <FormLabel required={requiredFields.includes(field.name)}>Project Name Alias</FormLabel>
                                            <Input {...field} />
                                            <FormMessage />
                                        </FormItem>
                                    );
                                }}
                            />

                            {/* Team Size */}
                            <FormField
                                control={form.control}
                                name="team_size"
                                render={({ field }) => {
                                    return (
                                        <FormItem>
                                            <FormLabel required={requiredFields.includes(field.name)}>Team Size</FormLabel>
                                            <Input
                                                type="number"
                                                step="1"
                                                inputMode="numeric"
                                                value={field.value ?? ""}
                                                onChange={(e) =>
                                                    field.onChange(
                                                        e.target.value === "" ? undefined : parseInt(e.target.value, 10)
                                                    )
                                                }
                                            />
                                            <FormMessage />
                                        </FormItem>
                                    );
                                }}
                            />

                            {/* Duration */}
                            <FormField
                                control={form.control}
                                name="duration"
                                render={({ field }) => {
                                    return (
                                        <FormItem>
                                            <FormLabel required={requiredFields.includes(field.name)}>Duration</FormLabel>
                                            <Input {...field} />
                                            <FormMessage />
                                        </FormItem>
                                    );
                                }}
                            />

                            {/* Portal buttons similar to TimesheetLog */}
                            <HeaderPortal>
                                {isNewItem ? (
                                    <Button
                                        variant="default"
                                        isLoading={isCreating}
                                        onClick={createItem}
                                    >
                                        Save
                                    </Button>
                                ) : (
                                    <Button
                                        variant="default"
                                        isLoading={isUpdating}
                                        disabled={!isDirty}
                                        onClick={updateItem}
                                    >
                                        Save
                                    </Button>
                                )}
                            </HeaderPortal>
                        </div>
                    );
                }}
            </Form>
        </div>
    );
};

export default BasicDetailsForm;
